export default {
    差价合约:'Hợp đồng chênh lệch ETF ',
    把握全球:'Giao dịch 100 CFD ETF toàn cầu phổ biến, bao gồm ETF cổ phiếu, trái phiếu theo từng chủ đề và từng loại đòn bẩy. Không cần tài khoản quỹ, giao dịch hai chiều có sử dụng đòn bẩy!',
    即刻开户:'Mở Tài khoản',
    优势:'Ưu điểm',
    差价合约是一种:'Hợp đồng chênh lệch ETF là công cụ tài chính linh hoạt, hỗ trợ giao dịch đòn bẩy hai chiều với các ETF chủ đạo toàn cầu, phù hợp với nhà đầu tư muốn tận dụng biến động thị trường và đa dạng hóa danh mục.',
    品种丰富:'Đa dạng sản phẩm',
    支持100:'Hỗ trợ giao dịch 100 loại ETF CFD phổ biến',
    灵活交易:'Giao dịch linh hoạt',
    支持买入:'Hỗ trợ mua/bán, tận dụng cơ hội khi giá tăng hoặc giảm',
    无需持有:'Không cần sở hữu tài sản',
    无需持有资产:'Dễ dàng giao dịch ETF toàn cầu mà không cần nắm giữ tài sản thực tế',
    杠杆交易:'Giao dịch đòn bẩy',
    杠杆配置:'Tỷ lệ đòn bẩy 5:1, nâng cao hiệu quả sử dụng vốn',
    开设模拟账户:'Mở tài khoản demo',
    开设真实账户:'Mở tài khoản thực',
    如何开始交易:'Cách bắt đầu giao dịch',
    注册账号:'Đăng ký tài khoản',
    注册并登录:'Đăng ký và đăng nhập vào trung tâm người dùng, hoàn tất xác minh danh tính',
    下载MT5交易平台:'Tải nền tảng giao dịch MT5',
    开通真实交易账号:'Mở tài khoản giao dịch thật trên MetaTrader 5',
    开始交易:'Bắt đầu giao dịch',
    选择ETF:'Chọn từ danh mục sản phẩm ETF CFD của chúng tôi',
    即刻交易:'Giao Dịch Ngay',
    差价合约相关问题:'Câu hỏi thường gặp về ETF CFD',
    有什么区别:'1.ETF CFD khác gì so với ETF truyền thống?',
    是差价合约交易:'ETF CFD là giao dịch hợp đồng chênh lệch, không liên quan đến việc giao nhận tài sản thực tế, không cần mở tài khoản chứng khoán hay nắm giữ ETF. Thích hợp cho chiến lược giao dịch ngắn hạn, hai chiều và sử dụng đòn bẩy.',
    购买ETF才能交易:'2. Tôi có cần mua ETF thực tế để giao dịch không?',
    通过EBC提供的ETF:'Không cần. Thông qua sản phẩm ETF CFD do EBC cung cấp, bạn có thể giao dịch dựa trên biến động giá ETF mà không cần sở hữu thực tế. Tất cả thao tác được thực hiện trên nền tảng giao dịch.',
    交易会收取哪些费:'3. Giao dịch ETF CFD cần những chi phí nào?',
    您无需支付传统ETF的管理费:'Bạn không cần trả phí quản lý hay hoa hồng như ETF truyền thống. Chi phí giao dịch chủ yếu là chênh lệch giá (spread) và phí tài chính cho lệnh giữ qua đêm. Mức phí cụ thể được hiển thị theo thời gian thực trên nền tảng.',
    可以做空吗:'4. ETF CFD có thể giao dịch bán khống không?',
    与传统ETF只能做多不:'Có thể. Khác với ETF truyền thống chỉ có thể mua lên, ETF CFD hỗ trợ giao dịch bán khống, phù hợp với chiến lược trong thị trường đi ngang hoặc giảm giá.',
    适合新手交易者:'5. ETF CFD có phù hợp với người mới không?',
    CFD产品具有杠杆属性:'CFD là sản phẩm có tính đòn bẩy, phù hợp với người dùng có hiểu biết về rủi ro và kinh nghiệm giao dịch nhất định. Chúng tôi khuyến nghị người mới nên bắt đầu với tài khoản demo để làm quen trước khi giao dịch thực tế.',
    市场报价:'Báo giá',
    查看所有产品:'Tất cả sản phẩm',
}